import Label from "components/Label";
import segment from "lib/segment";
import { useRouter } from "next/router";
import React, { FC } from "react";
import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import toast from "react-hot-toast";

import styles from "./styles.module.scss";

const BookATime: FC = () => {
  const router = useRouter();

  useCalendlyEventListener({
    onEventScheduled: () => {
      toast.success("Thanks for submitting, we'll redirect you!", {
        position: "top-right"
      });

      window.dataLayer.push({ event: "invitee_meeting_scheduled" });

      segment.track("LeadFlowTimeBooked", {});

      setTimeout(() => {
        toast.success(
          "We received your information, and are excited to speak with you! You’ll receive reminders for your scheduled call",
          { duration: 10000, position: "top-right" }
        );
        router.push("/");
      }, 2000);
    }
  });

  return (
    <div className={styles.container}>
      <Label className={styles.title} variant="h4-centered" color="primary2">
        Chat with Our Membership Director
      </Label>
      <Label
        className={styles.subtitle}
        variant="body-centered"
        color="primary2"
      >
        Feel free to book time to speak with our membership director, so we can
        support taking home maintenance off your plate. During your call,
        you&apos;ll discuss: your home&apos;s current needs, improvements to be
        made, and proactive and streamlined seasonal maintenance
      </Label>
      <InlineWidget
        styles={{ height: 1300 }}
        url="https://calendly.com/humminghomes/intro-call"
      />
    </div>
  );
};

export default BookATime;
